import { Component } from '@angular/core';
import {
  AuthenticationService,
  ParametersService,
  SubtitlesService
} from "../core";

@Component({
  selector: 'admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent {
  constructor(
      public authentication: AuthenticationService,
      public parameters: ParametersService,
      public subtitles: SubtitlesService,
  ) {}
}
